(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire39b1"];
var parcelRegister = parcelRequire.register;
parcelRegister("2JedE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b38550c6d0582f99$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");

var $fgnOF = parcelRequire("fgnOF");

var $kh3xj = parcelRequire("kh3xj");

var $aGT1k = parcelRequire("aGT1k");

var $bhAAH = parcelRequire("bhAAH");

var $7gWUw = parcelRequire("7gWUw");

var $96bGs = parcelRequire("96bGs");

var $ahcAq = parcelRequire("ahcAq");

const $b38550c6d0582f99$var$ChannelsContent = ()=>{
    const fetchResult = (0, $ahcAq.default)({
        url: `${"https://api.itsovertime.com"}/api/channels/v1?has_page=true`,
        key: "channels"
    });
    const channels = fetchResult.result.read();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $2MgeJ.Fragment), null, channels.sort((a, b)=>a.order - b.order).map((channel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $fgnOF.default), {
            channel: channel,
            key: channel.name
        })));
};
function $b38550c6d0582f99$var$Channels() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "channels"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", null, "Our Channels"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $bhAAH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($b38550c6d0582f99$var$ChannelsContent, null)));
}
function $b38550c6d0582f99$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $2MgeJ.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $aGT1k.default), {
        sticky: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "About content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "hero",
        style: {
            gridColumn: "full",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: `${(0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.OFFWHITE}`,
            textAlign: "center",
            width: "100vw",
            height: "calc(9 / 16 * 100vw)",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("video", {
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover"
        },
        ref: (ref)=>ref ? ref.playbackRate = 0.75 : null,
        autoPlay: true,
        muted: true,
        src: (0, $7gWUw.imgHeroVideoLandscapeMp4),
        loop: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "heroCopy",
        style: {
            zIndex: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h1", {
        style: {
            fontSize: "32px",
            fontFamily: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).FONT.BRAND,
            textTransform: "uppercase",
            margin: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).SIZE.GAP
        }
    }, "About"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        style: {
            margin: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).SIZE.GAP,
            lineHeight: "1.5",
            fontSize: "14px"
        }
    }, "Overtime builds disruptive new sports leagues aimed globally at the next generation of sports fans and athletes."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        className: "desktop-only",
        style: {
            display: "block",
            height: "400px",
            gridColumn: 2,
            gridRow: "1 / span 2",
            justifySelf: "end"
        },
        src: (0, $7gWUw.imgOvertimeLogoWhiteSvg)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "statsContainer",
        style: {
            gridColumn: "full",
            background: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_PRIMARY,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "stats",
        style: {
            display: "grid",
            gridTemplateColumns: "1fr",
            gridGap: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).SIZE.GAP,
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("span", {
        className: "one"
    }, "3"), "B+"), "views per month"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("span", {
        className: "one"
    }), "100M+"), "followers across 7 platforms"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h3", null, "81%"), " of our audience is under 35 years old"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h3", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("span", {
        className: "one"
    }, "3"), "00+"), "full time employees"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "copy",
        style: {
            gridColumn: "content",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).SIZE.GAP_2X
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($b38550c6d0582f99$var$Channels, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", null, "About Overtime"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("p", null, "Overtime builds disruptive new sports leagues and IP aimed globally at the next generation of sports fans and athletes. Overtime owns and operates, OTE and OT Select in basketball, OT7 in football and OTX in boxing, and leverages digital-first content across its network of accounts engaging its community of nearly 100 million fans and followers. Overtime's business model is driven by sponsorships, brand relationships, e-commerce, licensing and media rights."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("p", null, "Overtime is funded by top VC firms, industry leaders, and athletes, including Liberty Media Corporation, Andreessen Horowitz, Counterpoint Global (Morgan Stanley), Sapphire Sport, Winslow Capital, Bezos Expeditions, Spark Capital, Micromanagement Ventures (the family of the late David Stern), Black Capital, Blackstone Strategic Partners, Alexis Ohanian, Drake, Quavo and 40+ NBA and NFL stars including Carmelo Anthony, Kevin Durant and Trae Young. Over 6% of active NBA players have invested in Overtime.", " ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", null, "Contact Us"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("p", null, "Got a question for us? Want to make a content suggestion or send us some love?", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        style: {
            color: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_LINK,
            textDecoration: "none"
        },
        href: "/contact"
    }, "Get in touch with us"), ".")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $kh3xj.default), null));
}

});
parcelRegister("fgnOF", function(module, exports) {

$parcel$export(module.exports, "default", () => $18547929a3fe8322$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");

var $96bGs = parcelRequire("96bGs");

var $3eb6e = parcelRequire("3eb6e");

const $18547929a3fe8322$var$AboutChannel = ({ channel: channel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "AboutChannel",
        style: {
            display: "grid",
            gridTemplateColumns: "1fr",
            alignItems: "center",
            borderBottom: `1px solid ${(0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.DESATURATED_BLACK_BORDER}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h3", {
        style: {
            fontSize: "14px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        style: {
            borderRadius: "50%",
            border: "1px solid #efefef",
            width: "70px",
            height: "70px",
            marginRight: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).SIZE.GAP
        },
        alt: channel.name,
        src: `https://images.overtime.tv/channels/${channel.logo_path}?width=210`
    }), channel.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "desktop-only",
        style: {
            display: "block",
            color: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_PRIMARY,
            textAlign: "center",
            fontSize: "14px"
        }
    }, channel.topic), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "desktop-only",
        style: {
            display: "flex",
            paddingLeft: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).SIZE.GAP_2X
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $3eb6e.default), {
        channel: channel,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_PRIMARY
    })));
var $18547929a3fe8322$export$2e2bcd8739ae039 = $18547929a3fe8322$var$AboutChannel;

});
parcelRegister("3eb6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb8487911ac2aa2$export$2e2bcd8739ae039);

var $inQn1 = parcelRequire("inQn1");

var $gGcqq = parcelRequire("gGcqq");

var $lb9qR = parcelRequire("lb9qR");

var $dlnOP = parcelRequire("dlnOP");

var $dwB9P = parcelRequire("dwB9P");

var $bp9u1 = parcelRequire("bp9u1");

var $giM8N = parcelRequire("giM8N");

var $2MgeJ = parcelRequire("2MgeJ");

const $4cb8487911ac2aa2$var$ChannelSocial = ({ channel: channel, color: color = "black" })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "ChannelSocial",
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            fontSize: "14px",
            color: color
        }
    }, channel.youtube_id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        title: "YouTube",
        href: `https://youtube.com/@${channel.youtube_id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $bp9u1.faYoutube),
        size: "2x"
    })) : null, channel.instagram_id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        title: "Instagram",
        href: `https://instagram.com/${channel.instagram_id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $lb9qR.faInstagram),
        size: "2x"
    })) : null, channel.twitter_id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        title: "Twitter",
        href: `https://twitter.com/${channel.twitter_id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faXTwitter),
        size: "2x"
    })) : null, channel.facebook_id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        title: "Facebook",
        href: `https://facebook.com/${channel.facebook_id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $gGcqq.faFacebookF),
        size: "2x"
    })) : null, channel.twitch_id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        title: "Twitch",
        href: `https://twitch.tv/${channel.twitch_id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $dwB9P.faTwitch),
        size: "2x"
    })) : null, channel.tiktok_id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        title: "TikTok",
        href: `https://tiktok.com/@${channel.tiktok_id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $inQn1.faTiktok),
        size: "2x"
    })) : null, channel.snapchat_id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
        title: "Snapchat",
        href: `https://www.snapchat.com/add/${channel.snapchat_id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $giM8N.FontAwesomeIcon), {
        icon: (0, $dlnOP.faSnapchatGhost),
        size: "2x"
    }), " ") : null);
var $4cb8487911ac2aa2$export$2e2bcd8739ae039 = $4cb8487911ac2aa2$var$ChannelSocial;

});
parcelRegister("gGcqq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c24a34f4322e8a73$var$prefix = "fab";
var $c24a34f4322e8a73$var$iconName = "facebook-f";
var $c24a34f4322e8a73$var$width = 320;
var $c24a34f4322e8a73$var$height = 512;
var $c24a34f4322e8a73$var$aliases = [];
var $c24a34f4322e8a73$var$unicode = "f39e";
var $c24a34f4322e8a73$var$svgPathData = "M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z";
module.exports.definition = {
    prefix: $c24a34f4322e8a73$var$prefix,
    iconName: $c24a34f4322e8a73$var$iconName,
    icon: [
        $c24a34f4322e8a73$var$width,
        $c24a34f4322e8a73$var$height,
        $c24a34f4322e8a73$var$aliases,
        $c24a34f4322e8a73$var$unicode,
        $c24a34f4322e8a73$var$svgPathData
    ]
};
module.exports.faFacebookF = module.exports.definition;
module.exports.prefix = $c24a34f4322e8a73$var$prefix;
module.exports.iconName = $c24a34f4322e8a73$var$iconName;
module.exports.width = $c24a34f4322e8a73$var$width;
module.exports.height = $c24a34f4322e8a73$var$height;
module.exports.ligatures = $c24a34f4322e8a73$var$aliases;
module.exports.unicode = $c24a34f4322e8a73$var$unicode;
module.exports.svgPathData = $c24a34f4322e8a73$var$svgPathData;
module.exports.aliases = $c24a34f4322e8a73$var$aliases;

});

parcelRegister("dlnOP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7UTBI = parcelRequire("7UTBI");
module.exports.definition = {
    prefix: $7UTBI.prefix,
    iconName: $7UTBI.iconName,
    icon: [
        $7UTBI.width,
        $7UTBI.height,
        $7UTBI.aliases,
        $7UTBI.unicode,
        $7UTBI.svgPathData
    ]
};
module.exports.faSnapchatGhost = module.exports.definition;
module.exports.prefix = $7UTBI.prefix;
module.exports.iconName = $7UTBI.iconName;
module.exports.width = $7UTBI.width;
module.exports.height = $7UTBI.height;
module.exports.ligatures = $7UTBI.aliases;
module.exports.unicode = $7UTBI.unicode;
module.exports.svgPathData = $7UTBI.svgPathData;
module.exports.aliases = $7UTBI.aliases;

});
parcelRegister("7UTBI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5c38e5d53237e4b1$var$prefix = "fab";
var $5c38e5d53237e4b1$var$iconName = "snapchat";
var $5c38e5d53237e4b1$var$width = 512;
var $5c38e5d53237e4b1$var$height = 512;
var $5c38e5d53237e4b1$var$aliases = [
    62124,
    "snapchat-ghost"
];
var $5c38e5d53237e4b1$var$unicode = "f2ab";
var $5c38e5d53237e4b1$var$svgPathData = "M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z";
module.exports.definition = {
    prefix: $5c38e5d53237e4b1$var$prefix,
    iconName: $5c38e5d53237e4b1$var$iconName,
    icon: [
        $5c38e5d53237e4b1$var$width,
        $5c38e5d53237e4b1$var$height,
        $5c38e5d53237e4b1$var$aliases,
        $5c38e5d53237e4b1$var$unicode,
        $5c38e5d53237e4b1$var$svgPathData
    ]
};
module.exports.faSnapchat = module.exports.definition;
module.exports.prefix = $5c38e5d53237e4b1$var$prefix;
module.exports.iconName = $5c38e5d53237e4b1$var$iconName;
module.exports.width = $5c38e5d53237e4b1$var$width;
module.exports.height = $5c38e5d53237e4b1$var$height;
module.exports.ligatures = $5c38e5d53237e4b1$var$aliases;
module.exports.unicode = $5c38e5d53237e4b1$var$unicode;
module.exports.svgPathData = $5c38e5d53237e4b1$var$svgPathData;
module.exports.aliases = $5c38e5d53237e4b1$var$aliases;

});




parcelRegister("ahcAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee12643751482eb$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $zuniZ = parcelRequire("zuniZ");

var $k0r8C = parcelRequire("k0r8C");
function $fee12643751482eb$export$c931e3c99c4cf9a4(url, options, key) {
    const promise = (0, $zuniZ.default)(0).then(()=>fetch(url, {
            ...options,
            method: options?.method ?? "GET"
        })).then((r)=>r.json()).then((o)=>key ? o[key] : o);
    return {
        promise: promise,
        result: $fee12643751482eb$export$c36bebcb587f4928(promise),
        fetched: new Date()
    };
}
function $fee12643751482eb$export$c36bebcb587f4928(promise) {
    let status = "pending";
    let result;
    let error;
    let suspender = promise.then((r)=>{
        status = "success";
        result = r;
    }, (e)=>{
        status = "error";
        error = e;
    });
    return {
        read () {
            if (status === "pending") throw suspender;
            else if (status === "error") throw error;
            else if (status === "success") return result;
        }
    };
}
// Suspense relies on the promise being evaluated to be identical across renders
// However, when the promise resolves, Suspense rerenders all children from scratch
// This destroys any promises kept in state, whether its useState/useRef/useMemo
// To avoid this, we keep references to the promises outside of the React tree
// Take it up with the React team who designed Suspense
const $fee12643751482eb$var$fetches = {};
function $fee12643751482eb$var$useFetch({ url: url, options: options, key: key }) {
    const fetchResult = $fee12643751482eb$var$fetches[url] ?? $fee12643751482eb$export$c931e3c99c4cf9a4(url, options, key);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).isNil($fee12643751482eb$var$fetches[url])) $fee12643751482eb$var$fetches[url] = fetchResult;
    //If cached fetch is stale, fire a new fetch and replace the cached version if it completes
    // useFetch on the client is designed to be called once and cached after for a long time
    // with subsequent data updates being made by either WebSocket or explicit fetch
    // We allow for explicit data refetches for extremely long running windows
    const cacheExpiration = typeof window === "undefined" ? 5000 : 300000;
    if (new Date().getTime() - fetchResult.fetched.getTime() > cacheExpiration) {
        const newFetch = $fee12643751482eb$export$c931e3c99c4cf9a4(url, options, key);
        newFetch.promise.then(()=>$fee12643751482eb$var$fetches[url] = newFetch);
    }
    return fetchResult;
}
var $fee12643751482eb$export$2e2bcd8739ae039 = $fee12643751482eb$var$useFetch;
function $fee12643751482eb$export$81216966796c0505(options) {
    // Storing the data as an array avoids a lot of redundant code making updates
    const dataRef = (0, $2MgeJ.useRef)();
    // We need the useState to trigger rerenders when data updates
    // but mutably changing state data is a bad time so we
    // store the data in a ref then pipe it back out to the state
    const [data, setData] = (0, $2MgeJ.useState)();
    const dataIndexRef = (0, $2MgeJ.useRef)({});
    const { joinChannel: joinChannel } = (0, $2MgeJ.useContext)((0, $k0r8C.SocketContext));
    //Do initial setup once after the fetch promise resolves
    const fetchResult = $fee12643751482eb$var$useFetch(options);
    const fetchedData = fetchResult.result.read();
    const isArray = Array.isArray(fetchedData);
    (0, $2MgeJ.useEffect)(()=>{
        if (!dataRef.current) {
            if (isArray) dataRef.current = fetchedData;
            else dataRef.current = [
                fetchedData
            ];
            dataRef.current.forEach((d, i)=>dataIndexRef.current[d.id] = i);
            const singularKey = isArray ? options.key.slice(0, -1) : options.key;
            const pluralKey = isArray ? options.key : `${options.key}s`;
            const joinRelationChannel = (relation)=>{
                const relationSingularKey = relation.slice(0, -1);
                joinChannel({
                    channel: `public::${relation}`,
                    // Typescript doesn't have a way to dynamically handle keys like this
                    // but leaving in for clarity and future typing
                    // @ts-ignore
                    onMessage: (message)=>{
                        if (message[relationSingularKey]?.id) {
                            const newData = [
                                ...dataRef.current
                            ];
                            const index = dataIndexRef.current[message[relationSingularKey][`${singularKey}_id`]];
                            if (index >= 0) {
                                const relations = newData[index][relation] ?? [];
                                const relationIndex = relations.findIndex((t)=>t.id === message[relationSingularKey].id);
                                if (relationIndex >= 0) relations[relationIndex] = {
                                    ...relations[relationIndex],
                                    ...message[relationSingularKey]
                                };
                                else relations.push(message[relationSingularKey]);
                                newData[index] = {
                                    ...newData[index],
                                    [relation]: relations
                                };
                            }
                            setData(newData);
                        }
                    }
                });
            };
            joinChannel({
                channel: `public::${pluralKey}${!isArray ? `::${fetchedData.id}` : ""}`,
                // Typescript doesn't have a way to dynamically handle keys like this
                // but leaving in for clarity and future typing
                // @ts-ignore
                onMessage: (message)=>{
                    if (message[singularKey]?.id) {
                        const newData = [
                            ...dataRef.current
                        ];
                        const index = dataIndexRef.current[message[singularKey].id];
                        if (index >= 0) newData[index] = {
                            ...newData[index],
                            ...message[singularKey]
                        };
                        else {
                            newData.push(message[singularKey]);
                            dataIndexRef.current[message[singularKey].id] = newData.length - 1;
                        }
                        dataRef.current = newData;
                        setData(dataRef.current);
                    }
                }
            });
            for(const key in dataRef.current[0] ?? {})if (Array.isArray(dataRef.current[0][key])) joinRelationChannel(key);
            setData(dataRef.current);
        }
    }, []);
    const lastFocusFetchRef = (0, $2MgeJ.useRef)(new Date().getTime());
    (0, $2MgeJ.useEffect)(()=>{
        // There's room for optimization here as the socket
        // often survives a window blur/focus event
        // At some point should add a disconnect/reconnect event listener to the joinChannel
        // interface and trigger the full data fetch off that instead
        // For now just use a simple timer check to only refresh on focus once per minute
        const onFocus = async ()=>{
            if (new Date().getTime() - lastFocusFetchRef.current < 60000) return;
            lastFocusFetchRef.current = new Date().getTime();
            const { [options.key]: data } = await (await fetch(options.url)).json();
            if (isArray) dataRef.current = data;
            else dataRef.current = [
                data
            ];
            setData(dataRef.current);
        };
        window.addEventListener("focus", onFocus);
        return ()=>{
            window.removeEventListener("focus", onFocus);
        };
    }, []);
    // Until setState has executed, return the fetch
    if (!data) return fetchedData;
    if (Array.isArray(fetchedData)) return data;
    else return data[0];
}

});
parcelRegister("zuniZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $de4ddf5c42d382d3$export$2e2bcd8739ae039);
const $de4ddf5c42d382d3$var$wait = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
var $de4ddf5c42d382d3$export$2e2bcd8739ae039 = $de4ddf5c42d382d3$var$wait;

});

parcelRegister("k0r8C", function(module, exports) {

$parcel$export(module.exports, "SocketContext", () => $db8dedd8ce4a6a9f$export$86edbdc9a1e29ae8);

var $5RGWv = parcelRequire("5RGWv");

var $2MgeJ = parcelRequire("2MgeJ");
const $db8dedd8ce4a6a9f$var$defaultContext = {
    joinChannel: ()=>{}
};
const $db8dedd8ce4a6a9f$export$86edbdc9a1e29ae8 = /*#__PURE__*/ (0, $2MgeJ.createContext)($db8dedd8ce4a6a9f$var$defaultContext);
const { Provider: $db8dedd8ce4a6a9f$export$2881499e37b75b9a, Consumer: $db8dedd8ce4a6a9f$export$8a91f505d9122f1f } = $db8dedd8ce4a6a9f$export$86edbdc9a1e29ae8;
const $db8dedd8ce4a6a9f$export$783b29abdab77db7 = ({ children: children })=>{
    if (typeof WebSocket === "undefined") {
        if (typeof window !== "undefined") console.log("No WebSocket available");
        return /*#__PURE__*/ (0, $5RGWv.jsx)($db8dedd8ce4a6a9f$export$2881499e37b75b9a, {
            value: $db8dedd8ce4a6a9f$var$defaultContext,
            children: children
        });
    }
    const socketRef = (0, $2MgeJ.useRef)();
    const channelSubscribersRef = (0, $2MgeJ.useRef)({});
    const lastPingRef = (0, $2MgeJ.useRef)(new Date());
    const lastPongRef = (0, $2MgeJ.useRef)(new Date());
    const connectSocket = ()=>{
        console.log("Connecting");
        const socket = new WebSocket(`wss://notifications.itsovertime.com`);
        socket.onerror = (error)=>{
            console.error("WebSocket error", error);
        };
        socket.onclose = ()=>{
            if (socketRef.current !== socket) return;
        };
        socket.onopen = ()=>{
            console.log("Socket connected");
            lastPongRef.current = new Date();
            for(const channel in channelSubscribersRef.current){
                socketRef.current?.send(JSON.stringify({
                    data: {
                        action: "join_channel",
                        channel: channel,
                        is_user_channel: false
                    }
                }));
                console.log("Joined", channel);
            }
        };
        socket.onmessage = (e)=>{
            if (e.data === "pong") {
                lastPongRef.current = new Date();
                return;
            }
            const data = JSON.parse(e.data);
            if (data.channel) channelSubscribersRef.current[data.channel]?.forEach((fn)=>fn(JSON.parse(data.data)));
        };
        socketRef.current = socket;
    };
    (0, $2MgeJ.useEffect)(()=>{
        const id = setInterval(()=>{
            if (lastPingRef.current.getTime() - lastPongRef.current.getTime() > 3000 && socketRef.current?.readyState !== WebSocket?.CONNECTING) {
                socketRef.current?.close();
                socketRef.current = null;
                connectSocket();
                return;
            }
            if (socketRef.current?.readyState === WebSocket?.OPEN) {
                lastPingRef.current = new Date();
                socketRef.current?.send("ping");
            } else if (socketRef.current?.readyState !== WebSocket?.CONNECTING) connectSocket();
        }, 1000);
        return ()=>{
            clearInterval(id);
        };
    }, []);
    (0, $2MgeJ.useEffect)(()=>{
        connectSocket();
        return ()=>{
            socketRef.current?.close();
            socketRef.current = null;
        };
    }, []);
    const joinChannel = ({ channel: channel, onMessage: onMessage })=>{
        if (socketRef.current?.readyState === WebSocket?.OPEN) {
            socketRef.current?.send(JSON.stringify({
                data: {
                    action: "join_channel",
                    channel: channel,
                    is_user_channel: false
                }
            }));
            console.log("Joined", channel);
        } else {
            setTimeout(()=>{
                joinChannel({
                    channel: channel,
                    onMessage: onMessage
                });
            }, 1000);
            return;
        }
        channelSubscribersRef.current = {
            ...channelSubscribersRef.current,
            [channel]: [
                ...channelSubscribersRef.current[channel] || [],
                onMessage
            ]
        };
    };
    return /*#__PURE__*/ (0, $5RGWv.jsx)($db8dedd8ce4a6a9f$export$2881499e37b75b9a, {
        value: {
            joinChannel: joinChannel
        },
        children: children
    });
};

});



})();
//# sourceMappingURL=About.da3c4386.js.map
